import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { QuestionnaireStatus, Questionnaire } from '../../../Model/Questionnaire'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import LocalizationStore from '../../../Stores/LocalizationStore'
import QuestionnaireForm from '../../PartialViews/Questionnaire/QuestionnaireForm'
import { withRouter } from 'react-router'
import HttpActionsService from '../../../Services/HttpActionsService'
import QuestionnaireDetailsView from '../../PartialViews/Questionnaire/QuestionnaireDetailsView'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import { toJS } from 'mobx'
import ActionsLocalService from '../../../Services/ActionsLocalService'
import QuestionnaireCreateDetailsView from '../../PartialViews/Questionnaire/QuestionnaireCreateDetailsView'

export interface IQuestionnairesPageProps {
    questionnairesStore?: QuestionnairesStore
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    userStore?: UserStore
    match?: object
    actionsLocalService?: ActionsLocalService
}

@inject('localizationStore')
@inject('questionnairesStore')
@inject('httpActionsService')
@inject('userStore')
@inject('actionsLocalService')
@observer
class QuestionnairePage extends React.Component<IQuestionnairesPageProps> {

    // item: IQuestionnaire

    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }

        this.props.httpActionsService!.getAffiliates()

        if (this.props['match']!['params']['id']) {
            this.props.httpActionsService!.clearQuestionnaire()
            this.props.httpActionsService!.getQuestionnaire(this.props['match']!['params']['id'])
            
            // if (condition.isProgressiveAlgorithm) {
            HttpActionsService.getInstance().getScheduleConfiguration()
            // }

            // this.props.httpActionsService!.getPaymentsByQuestionnaireId(this.props['match']!['params']['id'])
        } else {
            // this.props.actionsLocalService!.initQ()
            // this.props.httpActionsService!.clearQuestionnaire()
        }
    }

    checkCanSave(): boolean {
        const { userStore, questionnairesStore } = this.props
        let questionnaire = questionnairesStore!.getItem
        return !questionnaire
            || (!questionnaire.status && questionnaire.status !== 0)
            || (questionnaire.status === QuestionnaireStatus.InProgressCreditConsultant &&
                userStore!.checkCreditConsultant &&
                questionnaire.inProgressByUserId === userStore!.id)
            || (userStore!.checkAdmin
                || userStore!.checkSuperAdmin
                || userStore!.checkCreditGroupAdministrator
                || userStore!.checkCollectionGroupAdministrator)
            || (userStore!.checkCreditExpert && questionnaire.status === QuestionnaireStatus.ActiveCredit)
    }

    checkCanClone(): boolean {
        const { userStore, questionnairesStore } = this.props
        let questionnaire = questionnairesStore!.getItem
        return questionnaire &&
            !!questionnaire.id &&
            (!(userStore!.checkLawyer || userStore!.checkCaller || userStore!.checkCollector)
                || userStore!.checkAdmin
                || userStore!.checkSuperAdmin
                || userStore!.checkCollectionGroupAdministrator
                || userStore!.checkCreditGroupAdministrator
                || userStore!.checkHardCaller)
    }

    checkCanCheck(): boolean {
        const { questionnairesStore } = this.props
        let questionnaire = questionnairesStore!.getItem
        return questionnaire && !!questionnaire.id
    }

    render() {

        const { questionnairesStore } = this.props
        let questionnaire = toJS(questionnairesStore!.getItem)

        if (!questionnaire) {
            questionnaire = new Questionnaire()
        }

        return (
            <div className="questionnairePage row">

                {
                    questionnaire.status || questionnaire.status === 0 ?
                        <QuestionnaireDetailsView
                            questionnaire={questionnaire}
                            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 blockCommentsWithStatus"
                        /> :
                        <QuestionnaireCreateDetailsView
                            questionnaire={questionnaire}
                            className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 blockCommentsWithStatus"
                        />
                }

                <QuestionnaireForm
                    className={'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 blockFormFields'}
                    questionnaire={questionnaire}
                    creditDetails={false}
                    hideSave={!this.checkCanSave()}
                    hideClone={!this.checkCanClone()}
                    hideCheck={!this.checkCanCheck()}
                />
            </div>
        )
    }
}

export default withRouter(QuestionnairePage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Questionnaire/QuestionnairePage.tsx